export default function(fn: any, wait = 1000, time?: any) {
  return (...args: any[]) => 
    //@ts-ignore
    clearTimeout(time, time = setTimeout(() => fn(...args), wait));

} 
